import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class MaintenanceHistoricoBastidorService {
  env = environment.env;
  historicoBastidorURL = endpointsURL.historicoBastidorURL;

  constructor(private httpClient: HttpClient) {}

  public list(filters?: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.historicoBastidorURL}/list${filters}`
    );
  }

  public createBastidor(item: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.env}${this.historicoBastidorURL}/edit`,
      item
    );
  }

  public editBastidor(item: any, id: string): Observable<any[]> {
    return this.httpClient.put<any[]>(
      `${this.env}${this.historicoBastidorURL}/edit/${id}`,
      item
    );
  }

  public getBastidor(filter: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.historicoBastidorURL}/edit/${filter}`
    );
  }

  public deleteBastidor(bastidor: string[]): Observable<any> {
    return this.httpClient.delete<any>(
      `${this.env}${this.historicoBastidorURL}/edit/${bastidor}`
    );
  }
}
